import React, { useState } from 'react';
import {
  Container,
  Grid,
  Typography,
  Card,
  CardMedia,
  Box,Stepper,Step ,StepLabel,List,ListItem,ListItemText,Divider,
} from '@mui/material';
import Webhead from './Webhead';
import canadaFlag from './img/canadaFlag.png';
import usaFlag from './img/usaFlag.png';
import ukFlag from './img/ukFlag.png';
import australiaFlag from './img/australiaFlag.png';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';
import { green } from '@mui/material/colors';
import Footer from './Webfoot'

const Courses = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);

  const countryFlags = [
    { title: 'Canada', image: canadaFlag },
    { title: 'Australia', image: australiaFlag },
    { title: 'USA', image: usaFlag },
    { title: 'UK', image: ukFlag },
  ];

  return (
    <Container maxWidth="xl" sx={{ my: 6 }}>
      <Typography variant="h4" color="primary" fontWeight={600} textAlign="center" gutterBottom>
        Trent Provides Migration Services to Australia, Canada, USA
      </Typography>
      <Typography variant="h4" textAlign="center" fontWeight={600} gutterBottom>
        Student Visa and Resident Visa
      </Typography>

      {/* Country Flags Section */}
      <Grid container spacing={4} justifyContent="center">
        {countryFlags.map((country, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                position: 'relative',
                height: '200px',
                overflow: 'hidden',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: 5, // Adds a shadow on hover
                },
              }}
            >
              <CardMedia
                component="img"
                height="100%"
                image={country.image}
                alt={country.title}
                sx={{ objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  bgcolor: 'rgba(0, 0, 0, 0.5)',
                  color: 'white',
                  padding: '10px',
                  borderRadius: '4px',
                  transition: 'background-color 0.3s',
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.7)', // Darken overlay on hover
                  },
                }}
              >
                <Typography variant="h5" fontWeight={700}>
                  {country.title}
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};


const ConversionRatios = () => {
    const conversionText = `
        TII has maintained a high conversion ratio with its partner universities. 
        The prime reason for this is we provide in-depth counseling to students 
        and help them in shortlisting appropriate universities. Selection of 
        University is done on the basis of the following parameters: – University Entry 
        Requirements, Course Structure, Fees, Location, and Student Preference. 
        After discussion with the student, we apply to 2-3 universities. Currently, we 
        are maintaining a conversion ratio of 35% – 40%. Along with every application 
        we provide a covering sheet, which makes it easier for Universities to process 
        applications. While applying, we make sure that applications are filled up 
        completely and are supported with required documents.
    `;
  
    return (
      <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '20px' }}>
        <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', fontFamily: 'Arial, sans-serif', fontSize: '2rem' }}>
          Conversion Ratios
        </Typography>
        <Typography style={{ fontFamily: 'Arial, sans-serif', fontSize: '1.3rem' }}>
          {conversionText}
        </Typography>
      </Container>
    );
  };
  

  const MarketingStrategy = () => {
    const marketingText = `
      OUR WORKING STRATEGY IS THAT WE WORK WITH LIMITED UNIVERSITIES/PARTNERS ONLY 
      SO THAT WE CAN MEET EVERY PARTNER’S EXPECTATIONS. WE AVOID REPRESENTING TWO 
      SIMILAR UNIVERSITIES SO THAT OUR COUNSELORS CAN FOCUS ON OUR EXISTING PARTNERS.
    `;
  
    return (
      <Container 
        maxWidth="xl" 
        style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          textAlign: 'center', 
          padding: '40px', 
          backgroundColor: '#f9f9f9', // Light background for better contrast
          borderRadius: '8px', // Rounded corners
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
        }}
      >
        <Typography 
          variant="h4" 
          gutterBottom 
          style={{ 
            fontWeight: 'bold', 
            fontFamily: 'Arial, sans-serif', 
            fontSize: '2rem', 
            color: '#333' 
          }}
        >
          Good Conversion Ratios
        </Typography>
        <Typography 
          style={{ 
            fontFamily: 'Arial, sans-serif', 
            fontSize: '1.2rem', 
            lineHeight: '1.6', 
            color: '#555' 
          }}
        >
          {marketingText}
        </Typography>
      </Container>
    );
  };
  

  const MarketingTools = () => {
    const tools = [
      "Online Media: Our main advertisement budget is fixed for online marketing. We promote our company on various education portals and search engines like Facebook, Google, Yahoo, etc. We have attached sample photos of our online marketing ahead in the presentation.",
      "Print Media: We have advertised with magazines apart from this we advertise in leading newspapers and magazines like Straits Times in Singapore and in India for e.g. Times of India, Hindustan Times, India Today and more.",
      "Just Dial: We are registered in premium category with Just Dial, which is India’s biggest and preferred directory. So we get the details for students who are interested in studying overseas.",
      "Seminars: We conduct seminars at various schools and colleges in Singapore, Bangladesh, and India.",
      "Exhibitions: We participate in several education and career fairs to promote our company and our partner Universities. Last year, we participated in Times Education Expo, Education fest and it was a big success for us. This year, we plan to participate in Times Education Expo, SS Educator, Star News Education Fair and HT Education Worldwide.",
      "Billboard: We also advertise in hoardings in prominent locations or institutional areas.",
      "Direct Marketing: We will also promote different programs by Direct Marketing. E.g. for Food Quality Management, we will send the course details to most of the food science students in our area through post, text, and email.",
      "Leaflet / Flyers Distribution: We distribute our flyers / leaflets at university areas.",
      "Promotion at Café Coffee Day: We advertise at Café Coffee Day, which is a major hangout place for students. We did this in Kanpur (Central India) and had an overwhelming response. No other consultant has done it in the past."
    ];
  
    return (
      <Container
        maxWidth="xl"
        style={{
          padding: '40px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          style={{
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            color: '#333',
            textAlign: 'center', // Center the title
          }}
        >
          Marketing Tools
        </Typography>
  
        <Stepper activeStep={-1} orientation="vertical" style={{ paddingBottom: '20px' }}>
          {tools.map((tool, index) => (
            <Step key={index}>
              <StepLabel>
                <Typography
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    color: '#007BFF', // Change color for better visibility
                    '&:hover': {
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Step {index + 1}: {tool.split(':')[0]}
                </Typography>
              </StepLabel>
              <Typography
                style={{
                  marginLeft: '30px',
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '1.2rem',
                  color: '#555',
                  paddingBottom: '10px', // Add spacing below each tool
                }}
              >
                {tool}
              </Typography>
            </Step>
          ))}
        </Stepper>
      </Container>
    );
  };


  const StudentSupportServices = () => {
    const supportServices = [
      "Career counselling and information about foreign education",
      "Choosing the most suitable course after judging his/her aptitude and interest",
      "Document preparation and admission formalities",
      "IELTS Registration and Coaching",
      "Financial aid assistance through scholarships information and loan assistance",
      "Pre-visa counselling and documentation for visa",
      "Making their travel and Insurance arrangements",
      "Arranging accommodation",
      "Pre Departure Briefing"
    ];
  
    return (
      <Container
        maxWidth="xl"
        style={{
          padding: '40px',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          style={{
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            color: '#333',
            textAlign: 'center', // Center the title
          }}
        >
          Student Support Services
        </Typography>
  
        <Divider style={{ margin: '20px 0' }} />
  
        <List>
          {supportServices.map((service, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={service}
                primaryTypographyProps={{
                  style: {
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '1rem',
                    color: '#555',
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Container>
    );
  };

// Styled components
const StyledAccordion = styled(Accordion)(({ theme }) => ({
  maxWidth: 1200,
  textAlign: 'left',
  borderRadius: '8px',

  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: green[500],
  color: '#fff',
  '&:hover': {
    backgroundColor: green[600],
  },
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
}));

const StyledList = styled('ul')(({ theme }) => ({
  paddingLeft: theme.spacing(4),
}));

const StyledListItem = styled('li')(({ theme }) => ({
  margin: '8px 0',
}));

const StudentSupportServicesAccordion = () => {
  return (
    <Box align="center" >
       <Typography variant="h4" color="primary" fontWeight={600} textAlign="center" gutterBottom>
        Student Support Services
      </Typography>

      <StyledAccordion >
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            Student Support Services
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            TII provides end-to-end solutions to students, right from career counseling to airport pickup. Our services include:
            <StyledList>
              <StyledListItem>Career counselling and information about foreign education</StyledListItem>
              <StyledListItem>Choosing the most suitable course after judging his/her aptitude and interest.</StyledListItem>
              <StyledListItem>Document preparation and admission formalities</StyledListItem>
              <StyledListItem>IELTS Registration and Coaching</StyledListItem>
              <StyledListItem>Financial aid assistance through scholarships information and loan assistance.</StyledListItem>
              <StyledListItem>Pre-visa counselling and documentation for visa</StyledListItem>
              <StyledListItem>Making their travel and Insurance arrangements</StyledListItem>
              <StyledListItem>Arranging accommodation.</StyledListItem>
              <StyledListItem>Pre Departure Briefing</StyledListItem>
            </StyledList>
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>

      <StyledAccordion>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            ISR Process
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            <strong>Student Recruitment</strong>
            <StyledList>
              <StyledListItem>Our International Recruitment Agent (ISA) who represents will professionally and enthusiastically communicate the feature of the universities/institutes and programs in person and through a variety of mediums to recruit targeted quality students to universities.</StyledListItem>
              <StyledListItem>Together with our principal, plan, develop and implement international recruitment strategies for Trent global specific and third party sponsored recruitment events.</StyledListItem>
              <StyledListItem>Work closely with admission in-charge person or team (teams: includes faculty, staff and admin)</StyledListItem>
              <StyledListItem>Develop online marketing effectively; add in features and news for international student’s webpage visitors.</StyledListItem>
              <StyledListItem>The main important role in this process includes generating the innovative ideas for admissions/recruitment related data and reports in support of evaluating recruitment strategies.</StyledListItem>
              <StyledListItem>Agents should clearly communicate to students about the course, course outcome, Tuition fee and assessments.</StyledListItem>
            </StyledList>
            <strong>Admission Process</strong>
            <StyledList>
              <StyledListItem>Telephonic interview with student applicants for verification</StyledListItem>
              <StyledListItem>Review application including credential evaluation for consideration of acceptance based upon admission criteria</StyledListItem>
              <StyledListItem>Specification for admission process duration</StyledListItem>
              <StyledListItem>Provide recommendation for the admission process in case of any clarification</StyledListItem>
            </StyledList>
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>

      <StyledAccordion>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            Student Facilities
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            TII is in-charge for receiving students from the airport and will arrange facilities such as accommodation, orientation, transportation guide, and every issue regarding student facilities.
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>

      <StyledAccordion>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
          aria-controls="panel4a-content"
          id="panel4a-header"
        >
          <Typography variant="h6" style={{ fontWeight: 'bold' }}>
            Sample Market Analysis By TII
          </Typography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>
          <Typography>
            We are aware of today’s educational global market place and marketing plays a vital strategic role in the success and expansion of our organization. With consideration of following key points we have decided to assign professional marketers or sub agents in the respective countries. The ultimate challenge is to find the right professional marketers with strategic marketing mindset.
            <br /><br />
            The market analysis is necessary tool for our counsellors and sub-agents, with different arrangements appropriate to different markets. Such arrangements will be reviewed on a regular basis to ensure that they are operating satisfactorily and effectively.
            <br /><br />
            In the current market, many schools/universities are running successfully by recruiting international students from various countries like India, Vietnam, Myanmar, Malaysia, etc. Thus, there is substantial evidence that our education programs and services are marketable. The below is a sample market analysis carried out for country India.
          </Typography>
        </StyledAccordionDetails>
      </StyledAccordion>
    </Box>
  );
};



const Adhome = () => {
  return (
    <div>
      <Webhead />
      <div>
        <Courses />
        <ConversionRatios />
      <MarketingStrategy />
      <br />
      <MarketingTools />
      <br />
      <StudentSupportServices />
      <br />
      <StudentSupportServicesAccordion />
      </div>
      <br/>
      <Footer/>
    </div>
  );
};

export default Adhome;
